export default {
  goodFaithCertifiedLabel: {
    id: 'report_illicit_content_good_faith_certified_label',
    defaultMessage:
      'I hereby certify that I am acting in good faith and that the information provided above is accurate and complete',
  },

  isTrustedFlaggerLabel: {
    id: 'report_illicit_content_is_trusted_flagger_label',
    defaultMessage:
      'I participate in the trusted flagger program and am submitting this report in my capacity as a trusted flagger under Article 22 of the Digital Services Act',
  },

  privacyPolicyText: {
    id: 'report_illicit_content_privacy_policy_text',
    defaultMessage:
      'Back Market collects your personal data in order to process your report and comply with its legal obligations. If you would like to learn more about how your personal data is processed, we invite you to consult our {privacyPolicy, html}.',
  },

  privacyPolicyLink: {
    id: 'report_illicit_content_privacy_policy_link',
    defaultMessage: 'Privacy Policy',
  },
}
